import React from "react";
import PropTypes from "prop-types";
import { ModalWindow } from "./ModalWindow";
import { I18nextProvider } from "react-i18next";
import { useTranslation } from "react-i18next";
import i18next from "./locales/i18next";

export const MoveMenuContext = React.createContext();

const i18n = i18next;

const changeLang = (lang) => {
  i18n.changeLanguage(lang);
};

export function MoveMenu(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  React.useEffect(() => {
    props.lang && changeLang(props.lang);
  }, [props.lang]);

  return (
    <I18nextProvider i18n={i18n}>
      <MoveMenuContext.Provider value={{}}>
        <ModalWindow
          modalOpen={props.modalOpen}
          toggleModal={props.toggleModal}
          interactionProps={props.interactionProps}
          alert={props.alert}
          notebookExpanded={props.notebookExpanded}
          lang={props.lang}
          component={props.component}
          componentString={t(props.component)}
          type={props.type}
          typeString={t(props.type)}
          connect={props.connect}
          targetList={props.targetList}
          setHeldObject={props.setHeldObject}
          calculatePosition={props.calculatePosition}
          teleport={props.teleport}
          setHeld={props.setHeld}
          setGelHeld={props.setGelHeld}
          setPowerSupplyLeadHeld={props.setPowerSupplyLeadHeld}
          setFlaskHeld={props.setFlaskHeld}
          setSolutionHeld={props.setSolutionHeld}
          setFloatingTubeRackHeld={props.setFloatingTubeRackHeld}
          setCellSpreaderHeld={props.setCellSpreaderHeld}
          setLabTapeHeld={props.setLabTapeHeld}
          setPetridishHeld={props.setPetridishHeld}
          setWasteCollectionJarHeld={props.setWasteCollectionJarHeld}
        />
      </MoveMenuContext.Provider>
    </I18nextProvider>
  );
}

MoveMenu.propTypes = {
  /**
   * specifies code of language the component is to be rendererd
   */
  lang: PropTypes.oneOf([
    "en",
    "az",
    "ar",
    "ja",
    "nl",
    "de",
    "es",
    "fr",
    "it",
    "ko",
    "pt",
    "tr",
    "zh",
    "zu",
  ]),

  //...ModalWindow.propTypes,
};

MoveMenu.defaultProps = {};
